import type { IHttpApi } from '@cian/http-api';
import type { ILogger } from '@cian/logger';
import { fetchGetUserProfile, type IMappers } from '../../repositories/chats/v1/get-user-profile';
import { EExceptionDomain } from '../../types/exceptionDomains';
import { IUserProfile } from '../../types/userProfile';
import { getGenericLikeError } from '../../utils/logging/getGenericLikeError';

import { DEFAULT_ERROR_MESSAGE } from './constants';
import { mapResponse200 } from './utils/mapResponse200';
import { mapResponse400 } from './utils/mapResponse400';

interface IParams {
  httpApi: IHttpApi;
  logger: ILogger;
  chatId: string;
}

export const getUserProfile = async (params: IParams): Promise<IUserProfile | null> => {
  const { httpApi, logger, chatId } = params;

  const parameters = {
    chatId,
  };

  const mappers: IMappers<IUserProfile, null> = {
    200: mapResponse200,
    400: mapResponse400,
  };

  try {
    const result = await fetchGetUserProfile({ httpApi, parameters, mappers });

    return result as IUserProfile;
  } catch (error) {
    const exception = getGenericLikeError({
      error,
      domain: EExceptionDomain.User,
      message: DEFAULT_ERROR_MESSAGE,
    });

    logger.warning(exception, {
      microserviceName: 'chats',
      pathApi: '/v1/get-user-profile/',
      parameters: JSON.stringify({ chatId }),
    });

    return null;
  }
};
